export default __webpack_public_path__ + "static/media/33.2d12bc11.png";